export const DAILY_CONTENT_KIND_VALUES = ["question", "fact"] as const

export type DailyContentKind = (typeof DAILY_CONTENT_KIND_VALUES)[number]
